import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import AdminNav from './shared/AdminNav';
import OverviewDashboard from './Overview/OverviewDashboard';
import UsageAnalytics from './Analytics/UsageAnalytics';
import SystemHealth from './SystemHealth/SystemHealth';
import DatabaseAdmin from './Database/DatabaseAdmin';

const AdminConsole = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('overview');

  // Listen for tab switch events from QuickActions
  React.useEffect(() => {
    const handleTabSwitch = (event) => {
      setActiveTab(event.detail);
    };

    window.addEventListener('switchAdminTab', handleTabSwitch);
    return () => window.removeEventListener('switchAdminTab', handleTabSwitch);
  }, []);

  // Only platform admins can access this console
  if (user?.role !== 'platform_admin') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-8 rounded-lg shadow-md max-w-md">
          <div className="flex items-center mb-4 text-red-600">
            <svg className="w-6 h-6 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
            <h2 className="text-xl font-bold">Access Denied</h2>
          </div>
          <p className="text-gray-700">
            This admin console is only accessible to platform administrators.
          </p>
        </div>
      </div>
    );
  }

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <OverviewDashboard />;
      case 'analytics':
        return <UsageAnalytics />;
      case 'system':
        return <SystemHealth />;
      case 'database':
        return <DatabaseAdmin />;
      default:
        return <OverviewDashboard />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="py-6">
            <h1 className="text-3xl font-bold text-gray-900">Admin Console</h1>
            <p className="mt-1 text-sm text-gray-600">
              Platform-wide analytics and system monitoring
            </p>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <AdminNav activeTab={activeTab} onTabChange={setActiveTab} />

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {renderContent()}
      </div>
    </div>
  );
};

export default AdminConsole;
